import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=4d1cbef2&scoped=true"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"
import style0 from "./Servicos.vue?vue&type=style&index=0&id=4d1cbef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1cbef2",
  null
  
)

export default component.exports